import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastMessage } from '../models/toast-message';
import { ToastMessageStateService } from '../services/toast-message.state.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ToastMessageAlertLevel } from '../enums/toast-message-alert-level.enum';

@UntilDestroy()
@Component({
    selector: 'bd-toast-message',
    templateUrl: './toast-message.component.html',
    styleUrls: ['./toast-message.component.scss']
})
export class ToastMessageComponent implements OnInit, OnDestroy {
    showMessage: boolean;
    message: ToastMessage;
    messageIcon: string;
    messageContainerClass: string;
    private messageTimer;
    private subscription: Subscription;

    constructor(
        private toastMessageStateService: ToastMessageStateService
    ) {
    }

    ngOnInit() {
        this.subscription = this.toastMessageStateService.$state
            .pipe(untilDestroyed(this))
            .subscribe((newMessage: ToastMessage) => {
                this.messageContainerClass = '';
                if (newMessage) {
                    switch (newMessage.level) {
                        case ToastMessageAlertLevel.ERROR:
                            this.messageIcon = 'fa-exclamation';
                            this.messageContainerClass = 'toast-message__container--exception';
                            break;
                        case ToastMessageAlertLevel.SUCCESS:
                            this.messageIcon = 'fa-check';
                            break;
                        default:
                            this.messageIcon = 'fa-check';
                            break;
                    }

                    if (this.messageTimer) {
                        clearTimeout(this.messageTimer);
                    }

                    this.messageTimer = null;
                    this.message = newMessage;
                    this.showMessage = true;
                    if (!newMessage.persist) {
                        const fadeOutByLevel = newMessage.level === ToastMessageAlertLevel.SUCCESS ? 3000 : 5000;

                        this.messageTimer = setTimeout(() => {
                            this.toastMessageStateService.resetToInitialState();
                        }, fadeOutByLevel);
                    }
                } else {
                    this.showMessage = false;
                }
            });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
